import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

// create slice

const name = "myAccount";
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports

export const myAccountActions = { ...slice.actions, ...extraActions };
export const myAccountReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    loading: null,
    LoadPublicUserDetails: {},
    userEmailExists: null,
    cancelMyAccountStatus: null,
    ReactivateStatus: [],
    PublicUserValidateLoginStatus: null,
    PublicUserValidateLoginStatusDetails: null,
  };
}

function createReducers() {
  return {
    clearuserEmailExistsResponse,
    clearPublicUserLoginStatusResponse
  };

  function clearPublicUserLoginStatusResponse(state) {
    state.PublicUserValidateLoginStatus = null;
    state.PublicUserValidateLoginStatusDetails = null;
  }
 
  function clearuserEmailExistsResponse(state) {
    state.userEmailExists = [];
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/MyAccount`;

  return {
    LoadPublicUserDetails: LoadPublicUserDetails(),
    PublicUserEmailUsernameExist: PublicUserEmailUsernameExist(),
    PublicUserCancelMyAccount: PublicUserCancelMyAccount(),
    PublicUserReactivatelMyAccount: PublicUserReactivatelMyAccount(),
    // PublicUserValidateLogin: PublicUserValidateLogin(),
    PublicUserValidateLoginDetails: PublicUserValidateLoginDetails(),
  };


  function LoadPublicUserDetails() {
    return createAsyncThunk(
      `${name}/LoadPublicUserDetails`,
      async (userID) => {
        const publicUserID = userID || getStoredValue("userID");
        if (!publicUserID) {
          throw new Error("User ID is not available ");
        }
  
        const response = await fetchWrapper.get(
          `${baseUrl}/LoadPublicUserDetails?publicUserID=${publicUserID}`
        );
        return response;
      }
    );
  }

    // Action for check username or email already exsists or not 
    function PublicUserEmailUsernameExist() {
    return createAsyncThunk(
      `${name}/PublicUserEmailUsernameExist`,
      async (myAccount) =>
        
        await fetchWrapper.get(
          `${baseUrl}/PublicUserEmailUsernameExist?publicUserID=${myAccount.publicUserID}&userName=${myAccount.userName}&email=${myAccount.email}`
        )
    );
  }

  // Public User Cancel Account Event
  function PublicUserCancelMyAccount() {
    return createAsyncThunk(
      `${name}/PublicUserCancelMyAccount`,
      async (myAccount) =>
        
        await fetchWrapper.get(
          `${baseUrl}/PublicUserCancelMyAccount?publicUserID=${myAccount.publicUserID}`
        )
    );
  }

  // Public User reactivate Account Event
  function PublicUserReactivatelMyAccount() {
    return createAsyncThunk(
      `${name}/PublicUserReactivateMyAccount`,
      async (LoginDetails) =>
        
        await fetchWrapper.get(
          `${baseUrl}/PublicUserReactivateMyAccount?userName=${LoginDetails.UserName}&userPassword=${LoginDetails.UserPassword}`
        )
    );
  }
  //  function PublicUserValidateLogin() {
  //     return createAsyncThunk(
  //       `${name}/PublicUserValidateLogin`,
  //       async ({ publicUserID, PUPasswordLogID }) =>
  //         await fetchWrapper.post(
  //           `${baseUrl}/PublicUserValidateLogin?publicUserID=${publicUserID}&PUPasswordLogID=${PUPasswordLogID}`
  //         )
  //     );
  //   }

    function PublicUserValidateLoginDetails() {
      return createAsyncThunk(
        `${name}/PublicUserValidateLoginDetails`,
        async ({ publicUserID, PUPasswordLogID }) =>
          await fetchWrapper.post(
            `${baseUrl}/PublicUserValidateLoginDetails?publicUserID=${publicUserID}&PUPasswordLogID=${PUPasswordLogID}`
          )
      );
    }
}


function createExtraReducers(builder) {
  builder
    // Initially Load My Accounts page data
    .addCase(extraActions.LoadPublicUserDetails.pending, (state) => {
      //state.LoadPublicUserDetails = { loading: true };
    })
    .addCase(extraActions.LoadPublicUserDetails.fulfilled, (state, action) => {
      state.LoadPublicUserDetails = action.payload[0];
    })
    .addCase(extraActions.LoadPublicUserDetails.rejected, (state, action) => {
      //state.LoadPublicUserDetails = { error: action.error };
    })

    // Check UserName or Email Alreay Exists
    .addCase(extraActions.PublicUserEmailUsernameExist.pending, (state) => {
      //state.userEmailExists = { loading: true };
    })
    .addCase(
      extraActions.PublicUserEmailUsernameExist.fulfilled,
      (state, action) => {
        state.userEmailExists = action.payload;
      }
    )
    .addCase(
      extraActions.PublicUserEmailUsernameExist.rejected,
      (state, action) => {
        state.userEmailExists = { error: action.error };
      }
    )

    // Public User Cancel Account Event
    .addCase(extraActions.PublicUserCancelMyAccount.pending, (state) => {
      // state.userEmailExists = { loading: true };
    })
    .addCase(
      extraActions.PublicUserCancelMyAccount.fulfilled,
      (state, action) => {
        state.cancelMyAccountStatus = action.payload;
      }
    )
    .addCase(
      extraActions.PublicUserCancelMyAccount.rejected,
      (state, action) => {
        state.cancelMyAccountStatus = { error: action.error };
      }
    )

    // Public User Reactivate Account Event
    .addCase(extraActions.PublicUserReactivatelMyAccount.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(
      extraActions.PublicUserReactivatelMyAccount.fulfilled,
      (state, action) => {
        state.ReactivateStatus = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      extraActions.PublicUserReactivatelMyAccount.rejected,
      (state, action) => {
        state.error = { error: action.error };
        state.loading = false;
      }
    )
    // Public User Reactivate Account Event
    // .addCase(extraActions.PublicUserValidateLogin.pending, (state) => {
    //   state.loading = true ;
    // })
    // .addCase(
    //   extraActions.PublicUserValidateLogin.fulfilled,
    //   (state, action) => {
    //     state.PublicUserValidateLoginStatus = action.payload;
    //     state.loading = false;
    //   }
    // )
    // .addCase(extraActions.PublicUserValidateLogin.rejected, (state, action) => {
    //   state.error = { error: action.error };
    //   state.loading = false;
    // })


    // Public User Reactivate Account Event New for get UserName and Password
    .addCase(extraActions.PublicUserValidateLoginDetails.pending, (state) => {
      state.loading = true ;
    })
    .addCase(
      extraActions.PublicUserValidateLoginDetails.fulfilled,
      (state, action) => {
        state.PublicUserValidateLoginStatusDetails = action.payload;
        state.loading = false;
      }
    )
    .addCase(extraActions.PublicUserValidateLoginDetails.rejected, (state, action) => {
      state.error = { error: action.error };
      state.loading = false;
    });
}
